// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34f2cad3","455":"70d55719","977":"cec7c97f"}[chunkId] + ".chunk.js";
};